import React from 'react';
import { AlertIconWrapper, TrendTooltip } from '../../components/Table/styles';
import { AiOutlineWarning } from 'react-icons/ai';
import { TrendAlerts } from '../constants/trendAlertsInfo';

const getFilteredAlerts = (status: any): string[] => 
    Object.keys(status)
        .filter(key => (key.endsWith('StatusTrend') || key.endsWith('Trend')) && status[key])
        .map(key => {
            let formattedKey = key.replace(/StatusTrend|Trend/g, '').toLowerCase();
            if (formattedKey.startsWith('strg')) {
                formattedKey = formattedKey.slice(4);
            }
            if (formattedKey.startsWith('fatigue')) {
                formattedKey = formattedKey.slice(7);
            }
            if (formattedKey === 'internalrotation') {
                formattedKey = 'ir';
            }
            if (formattedKey === 'externalrotation') {
                formattedKey = 'er';
            }
            if (formattedKey === 'total') {
                formattedKey = 'totalstrenght'
            }
            return formattedKey;
        });

const getAlertZoneBullet = (status: any, alert: boolean, type: string) => {
    if (!alert) return null;

    const filteredAlerts = getFilteredAlerts(status);
    if (filteredAlerts.length === 0) return null;

    const muscleType = filteredAlerts.length > 1 ? 'multiple' : filteredAlerts[0];
    const typeZone = type === 'zone 2' ? 'Warning' : 'Medical';
    const message = {
        title: `${typeZone} Alert`,
        description: TrendAlerts[muscleType]?.[typeZone.toLowerCase()]
    }
    if(!message.title || !message.description) return null;

    return (
        <AlertIconWrapper style={{ top: '3px', right: '3px', position: 'absolute' }}>
            <AiOutlineWarning size="13px" color='gray' />
            <TrendTooltip>
                <p>{message.title}</p>
                <span>{message.description}</span>
            </TrendTooltip>
        </AlertIconWrapper>
    );
};

export default getAlertZoneBullet;
